import * as React from 'react';

const SectionRightFillSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        id="section-right-fill_svg__eds-icon--section-right-fill_svg"
        x={0}
        y={0}
        viewBox="0 0 24 24"
        xmlSpace="preserve"
        {...props}
    >
        <path
            id="section-right-fill_svg__eds-icon--section-right-fill_base"
            fill="#010101"
            d="M12 20h8v-4h-8v4z"
        />
        <path
            id="section-right-fill_svg__eds-icon--section-right-fill_middle"
            fill="#010101"
            d="M4 10v4h16v-4H4z"
        />
        <path
            id="section-right-fill_svg__eds-icon--section-right-fill_top"
            fill="#010101"
            d="M4 4v4h16V4H4z"
        />
    </svg>
);

SectionRightFillSvg.displayName = 'SectionRightFillSvg';
export default SectionRightFillSvg;
